import { useNavigate } from 'react-router-dom';
import { FiAlignJustify } from "react-icons/fi"
import { BsWindowFullscreen, BsPower } from "react-icons/bs"

const toggleFullScreen = () => {
	if ((document.fullScreenElement && document.fullScreenElement !== null) ||
		(!document.mozFullScreen && !document.webkitIsFullScreen)) {
		if (document.documentElement.requestFullScreen) {
			document.documentElement.requestFullScreen();
		} else if (document.documentElement.mozRequestFullScreen) {
			document.documentElement.mozRequestFullScreen();
		} else if (document.documentElement.webkitRequestFullScreen) {
			document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
		}
	} else {
		if (document.cancelFullScreen) {
			document.cancelFullScreen();
		} else if (document.mozCancelFullScreen) {
			document.mozCancelFullScreen();
		} else if (document.webkitCancelFullScreen) {
			document.webkitCancelFullScreen();
		}
	}
}


const Header = (props) => {
    let navigate = useNavigate();
    const logout = () => {
		localStorage.removeItem('accessToken')
		navigate('/login')
	}

    return (
        <div className='header sticky top-0 z-10 h-16 bg-white text-slate-500 '>
            <div className='flex items-center justify-between min-h-[64px] pl-4 pr-8 border-b border-b-slate-200 '>
                <div className='flex items-center gap-x-2'>
                    <button onClick={() => { props.setIsOpenSidebar(!props.isOpenSidebar) }} className='text-xl  transition-all duration-150 rounded-full hover:bg-white  p-2 hover:outline-dashed outline-1  '>
                        <FiAlignJustify />
                    </button>
                    <h1 className='font-semibold text-slate-700 '>ENSTİTÜ FORM YÖNETİM SİSTEMİ</h1>
                </div>
                <div>
                    <ul className='flex items-center gap-x-3 text-lg text-slate-500  '>
                        <li>
                            <button onClick={toggleFullScreen} className='hover:outline-dashed focus:outline-dashed outline-offset-1 outline-1 outline-slate-200  rounded-full transition-all duration-150 hover:bg-slate-200  p-2'><BsWindowFullscreen /></button>
                        </li>
                        <li>
                            <button onClick={() => logout()} className='hover:outline-dashed focus:outline-dashed outline-offset-1 outline-1 outline-slate-200  rounded-full transition-all duration-150 hover:bg-slate-200  p-2'><BsPower /></button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Header;
